import { ref, watch, onMounted, onUnmounted } from 'vue'

export function useTheme() {
  const isDarkTheme = ref(false)
  
  
  const loadTheme = () => {
    const savedTheme = localStorage.getItem('theme')
    
    if (savedTheme) {
      isDarkTheme.value = savedTheme === 'dark'
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      isDarkTheme.value = prefersDark
    }
  }
  
 
  const saveTheme = () => {
    localStorage.setItem('theme', isDarkTheme.value ? 'dark' : 'light')
  }

  const applyThemeToHtml = () => {
    if (isDarkTheme.value) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  const toggleTheme = () => {
    isDarkTheme.value = !isDarkTheme.value
    saveTheme()
    applyThemeToHtml()
  }
  

  const setTheme = (theme) => {
    isDarkTheme.value = theme === 'dark'
    saveTheme()
    applyThemeToHtml()
  }
  

  onMounted(() => {
    loadTheme()
    applyThemeToHtml()
    
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleSystemThemeChange = (e) => {
      if (!localStorage.getItem('theme')) {
        isDarkTheme.value = e.matches
        applyThemeToHtml()
      }
    }
    
    mediaQuery.addEventListener('change', handleSystemThemeChange)
    
    onUnmounted(() => {
      mediaQuery.removeEventListener('change', handleSystemThemeChange)
    })
  })
  

  watch(isDarkTheme, () => {
    applyThemeToHtml()
  })
  
  return {
    isDarkTheme,
    toggleTheme,
    setTheme
  }
}